import {useFormik} from "formik";
import {Button, Input, Modal, Select} from "antd";
import React, {useEffect, useState} from "react";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useApiUpdateTeacherProfile} from "@/api/userAcademy";
import CleaveInput from "@/components/cleave-input/cleaveInput";
import {useApiLocationCountry} from "@/api/location";
import {toJalaliYYYYMMDD} from "@/lib/helper/date";
import {ErrorMessageWidget, FormField} from "@/pages/student/profile/_section/changeLocationModal";

export default function ChangeProfileModalSection({user, onSubmit, onClose, openModal}) {
    const [loading, setLoading] = useState(false);
    const [countryList, setCountryList] = useState([])
    const {data: country} = useApiLocationCountry()

    const {mutate: updateProfile} = useApiUpdateTeacherProfile();

    useEffect(() => {
        if (country) {

            setCountryList(country?.data)
        }
    }, [country])

    const formik = useFormik({
        initialValues: {
            firstname: user?.firstname,
            lastname: user?.lastname,
            father: user?.father,
            birthdate: toJalaliYYYYMMDD(user?.birthdate),
            marital: user?.marital,
            nationalcode: user?.nationalcode,
            pasportcode: user?.pasportcode,
            pasportdate: toJalaliYYYYMMDD(user?.pasportdate),
            nationalcodePretty: user?.nationalcode,
            nationality: user?.nationality,
            shfrom: user?.shfrom,
        },
        validate: (values) => {
            const errors = {};
            // if (!values.firstname) errors.firstname = "نام الزامی است";
            // if (!values.lastname) errors.lastname = "نام خانوادگی الزامی است";
            // if (!values.father) errors.father = "نام پدر الزامی است";
            // if (!values.birthdate) errors.birthdate = "تاریخ تولد الزامی است";
            // if (!values.marital) errors.marital = "وضعیت تاهل الزامی است";

            return errors;
        },
        onSubmit: (values) => {

            setLoading(true);
            updateProfile(values, {
                onSuccess: (res) => {
                    onSubmit(res);
                    ApiHandleSuccessMessage(res);
                    setLoading(false);
                },
                onError: (errors) => {
                    ApiHandleErrorMessage(errors);
                    setLoading(false);
                },
            });
        },
    });


    return (
        <Modal
            title={"اطلاعات هویتی خود را با دقت وارد کنید"}
            open={openModal}
            onCancel={() => {
                onClose?.();
            }}
            footer={[
                <Button onClick={() => onClose?.()}>لغو</Button>,
                <Button
                    type="primary"
                    loading={loading}
                    disabled={loading}
                    onClick={() => formik.submitForm()}
                >
                    ذخیره
                </Button>,
            ]}
        >
            <div className="flex flex-col gap-3">

                {/* نام */}
                <FormField label="نام" name="firstname">
                    <Input
                        disabled={user?.lock || user?.sabteahval}
                        name="firstname"
                        value={formik.values.firstname}
                        onChange={(e) => formik.setFieldValue('firstname', e.target.value)}
                    />
                    {formik.errors.firstname && <ErrorMessageWidget message={formik.errors.firstname}/>}
                </FormField>

                {/* نام خانوادگی */}
                <FormField label="نام خانوادگی" name="lastname">
                    <Input
                        disabled={user?.lock || user?.sabteahval}
                        name="lastname"
                        value={formik.values.lastname}
                        onChange={(e) => formik.setFieldValue('lastname', e.target.value)}
                    />
                    {formik.errors.lastname && <ErrorMessageWidget message={formik.errors.lastname}/>}
                </FormField>

                {/* نام پدر */}
                <FormField label="نام پدر" name="father">
                    <Input

                        name="father"
                        value={formik.values.father}
                        onChange={(e) => formik.setFieldValue('father', e.target.value)}

                    />
                    {formik.errors.father && <ErrorMessageWidget message={formik.errors.father}/>}
                </FormField>

                {/* تاریخ تولد */}
                <FormField label="تاریخ تولد" name="birthdate">
                    <CleaveInput
                        disabled={user?.lock || user?.sabteahval}
                        style={{direction: 'ltr'}}
                        type="tel"
                        autoComplete="off"
                        options={{delimiter: '/', blocks: [4, 2, 2]}}
                        name="birthdate"
                        value={formik.values.birthdate}
                        onChange={(e) => formik.setFieldValue("birthdate", e.target.value)}

                    />
                    {formik.errors.birthdate && <ErrorMessageWidget message={formik.errors.birthdate}/>}
                </FormField>

                {/* وضعیت تاهل */}
                <FormField label="وضعیت تاهل" name="marital">
                    <Select
                        value={formik.values.marital}
                        onChange={(value) => formik.setFieldValue("marital", value)}
                        options={[
                            {label: "مجرد", value: "single"},
                            {label: "متاهل", value: "married"},
                        ]}
                    />
                    {formik.errors.marital && <ErrorMessageWidget message={formik.errors.marital}/>}
                </FormField>
                <div>
                    <FormField label="ملیت" name="nationality">

                        <Select
                            disabled={user?.lock || user?.sabteahval}
                            defaultValue={formik.values.nationality}
                            className={'block'}
                            placeholder={'انتخاب کنید'}
                            id={'nationality'}
                            onChange={(e) => formik.setFieldValue('nationality', e)}
                            options={countryList.map((value, i) => {
                                return {value: value.key, label: value.fa_name}
                            })}
                        />
                    </FormField>


                </div>


                {formik.values.nationality === 'IR' && (<>
                        <FormField label="کد ملی" name="nationalcode">
                            <CleaveInput
                                disabled={user?.lock || user?.sabteahval}
                                style={{direction: 'ltr'}}
                                type="tel" placeholder="کد ملی ۱۰ رقمی *"
                                autoComplete="off"
                                options={{delimiter: ' - ', blocks: [3, 6, 1]}}
                                name="nationalcode"
                                value={formik.values.nationalcodePretty}
                                onChange={(e) => {
                                    formik.setFieldValue("nationalcode", e.target.rawValue)
                                    formik.setFieldValue("nationalcodePretty", e.target.value)
                                }}
                            />
                            {formik.errors.nationalcode && <ErrorMessageWidget message={formik.errors.nationalcode}/>}
                        </FormField>
                        <FormField label="محل صدور شناسنامه" name="shfrom">
                            <Input

                                name="shfrom"
                                value={formik.values.shfrom}
                                onChange={(e) => formik.setFieldValue('shfrom', e.target.value)}
                            />
                        </FormField>
                    </>

                )}
                {formik.values.nationality !== 'IR' && <>
                    {/* کد پاسپورت */}
                    <FormField label="کد پاسپورت" name="pasportcode">
                        <Input

                            style={{direction: 'ltr'}}
                            name="pasportcode"
                            value={formik.values.pasportcode}
                            onChange={(e) => formik.setFieldValue('pasportcode', e.target.value)}
                        />
                    </FormField>

                    {/* تاریخ انقضای پاسپورت */}
                    <FormField label="تاریخ انقضای پاسپورت" name="pasportdate">
                        <CleaveInput
                            style={{direction: 'ltr'}}
                            type="tel"
                            autoComplete="off"
                            options={{delimiter: '/', blocks: [4, 2, 2]}}
                            name="pasportdate"
                            value={formik.values.pasportdate}
                            onChange={(e) => formik.setFieldValue("pasportdate", e.target.value)}

                        />
                    </FormField>

                </>}

            </div>
        </Modal>
    );
}
